import { SmartLink, Button, YStack, isWeb } from '@my/ui'
import React from 'react'
import config from 'app/config'

interface RegisterButtonsProps {
  offerSlug?: string
  embedUrl?: string
}

export function RegisterButtons({ offerSlug, embedUrl }: RegisterButtonsProps) {
  const linkSuffix = offerSlug ? `?offerSlug=${offerSlug}&isEmbed=true` : ''

  const postMessage = (type: string, payload: any = {}) => {
    if (!isWeb) return
    parent.postMessage(
      {
        type,
        payload,
      },
      embedUrl || config.siteUrl
    )
  }

  const embedJoinClick = (e) => {
    if (!isWeb) return
    e.preventDefault()

    const joinUrl = `${config.siteUrl}/sign-up${linkSuffix}`

    postMessage('join', joinUrl)
  }

  return (
    <YStack pt="$4" gap="$3" width="100%" maxWidth={400}>
      <SmartLink
        theme='primary'
        w="100%"
        size="$4"
        fontWeight="600"
        Component={Button}
        href={`/log-in-embed${linkSuffix}`}
      >
        Log In & Redeem
      </SmartLink>

      <Button size="$4" fontWeight="600" unstyled w="100%" onPress={embedJoinClick}>
        Join Now & Get Code
      </Button>
    </YStack>
  )
}
